import React from 'react';
import './NewsroomPage.css';

const articles = [
  {
    year: '2025',
    title: 'Wrap raises seed to build safer social spaces',
    blurb:
      'We are building a more intentional way to connect—less noise, more trust. Our seed unlocks product and safety investments.',
    img: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1080&auto=format&fit=crop',
  },
  {
    year: '2025',
    title: 'Launching Wrap Beta',
    blurb:
      'Early communities are opening up. We are focused on authenticity, private spaces, and thoughtful discovery.',
    img: 'https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=1080&auto=format&fit=crop',
  },
  {
    year: '2026',
    title: 'Wrap expands to new regions',
    blurb:
      'We are carefully expanding while keeping our core promise—safety, simplicity, and real connection.',
    img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1080&auto=format&fit=crop',
  },
];

const NewsroomPage: React.FC = () => {
  React.useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>('.newsroom .reveal'));
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && (e.target as HTMLElement).classList.add('in-view'));
    }, { threshold: 0.12 });
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section className="newsroom">
      <header className="newsroom__hero reveal">
        <div className="news_sparkles" aria-hidden>
          <svg className="news_sparkle ns1" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3 L12.8 8.2 L18 9 L12.8 9.8 L12 15 L11.2 9.8 L6 9 L11.2 8.2 Z" stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <svg className="news_sparkle ns2" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4 L12.6 8 L16 8.6 L12.6 9.2 L12 13 L11.4 9.2 L8 8.6 L11.4 8 Z" stroke="currentColor" strokeWidth="0.9" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <svg className="news_sparkle ns3" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2 L13.2 8.8 L20 10 L13.2 11.2 L12 18 L10.8 11.2 L4 10 L10.8 8.8 Z" stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <svg className="news_sparkle ns4" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5 L12.4 7.6 L15 8 L12.4 8.4 L12 11 L11.6 8.4 L9 8 L11.6 7.6 Z" stroke="currentColor" strokeWidth="0.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <svg className="news_sparkle ns5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3 L13 9 L19 10 L13 11 L12 17 L11 11 L5 10 L11 9 Z" stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className="newsroom__title">Newsroom.</h1>
        <p className="newsroom__subtitle">Updates and stories from Wrap.</p>
      </header>

      {/* Flowing dotted lines background */}
      <svg className="flowBG" viewBox="0 0 1800 520" preserveAspectRatio="none" aria-hidden>
        <g fill="none" stroke="rgba(208, 208, 208, 0.17)" strokeWidth="1.1" strokeLinecap="round" strokeDasharray="2 12">
          {/* three highly loopy, vertically spaced paths that traverse full width */}
          <path className="flowBG__path p1" d="M-200 60 C 80 10, 220 140, 340 60 S 540 40, 640 140 S 820 40, 960 120 S 1140 60, 1260 140 S 1480 80, 1600 120 S 1720 60, 2000 100"/>
          <path className="flowBG__path p2" d="M-100 220 C 60 300, 220 200, 360 280 S 560 240, 680 320 S 860 260, 1000 340 S 1200 300, 1340 380 S 1540 340, 1660 400 S 1780 360, 1900 380"/>
          <path className="flowBG__path p3" d="M-100 360 C 100 420, 260 340, 380 420 S 600 380, 740 440 S 940 400, 1100 460 S 1360 420, 1520 480 S 1680 440, 1900 460"/>
        </g>
      </svg>

      {['2026', '2025'].map((year) => (
        <div className="pillGroup reveal" key={year} style={{ ['--delay' as any]: '160ms' }}>
          <div className="pillKicker">{year}</div>
          {articles.filter((a) => a.year === year).map((a, i) => (
            <div className="pill pill--news reveal" style={{ ['--delay' as any]: `${220 + i * 120}ms` }} key={a.title}>
              <div className="pill__left">
                <div className="pill__title">{a.title}</div>
                <div className="pill__meta">{a.blurb}</div>
              </div>
              <div className="pill__media" style={{ backgroundImage: `url(${a.img})` }} />
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default NewsroomPage;


